import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType, PrescriptionHistoryStatePreviousItem } from '../types';

export const updatePrescriptionHistoryPreviousItems: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (previousItems: PrescriptionHistoryStatePreviousItem[]) => void
> = (set) => (previousItems) =>
  set(
    (state: PrescriptionAssistantSliceType) => {
      state.prescriptionAssistant.prescriptionHistory.previousItems = previousItems;
    },
    false,
    'prescriptionHistory/updatePrescriptionHistoryPreviousItems',
  );
